import React from "react"
import clsx from 'clsx'
import I18n from "i18n-js"
import MessageLogWorkspace from "./MessageLogWorkspace"
import Tabs from "../Tabs/Tabs";

class MessageLog extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      message_active_tab: 'conversation'
    }

    this.setActiveTab = this.setActiveTab.bind(this);
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'message_logs',
      'tab-pane': true
    });
    
    return (
      <div className={tabClasses} id="message_logs">
        <Tabs tabs={this.tabs()}/>
        <MessageLogWorkspace {...this.state} {...this.props}/>
      </div>
    )
  }

  tabs() {
    var tabs = [];

    tabs.push({
      tabName: I18n.t('conversation'),
      targetName: 'conversation',
      classes: this.state.message_active_tab === 'conversation' ? "active" : null,
      changeHandler: this.setActiveTab,
    });

    tabs.push({
      tabName: I18n.t('templates'),
      targetName: 'templates',
      classes: this.state.message_active_tab === 'templates' ? "active" : null,
      changeHandler: this.setActiveTab,
    });

    return tabs;
  }

  setActiveTab(tab) {
    this.setState({
      message_active_tab: tab,
    });
  }
}

export default MessageLog